import React from 'react';
import { formatRelativeTime } from '../../utils/formatters';

const IncidentsList = ({ incidents }) => {
  if (!incidents || incidents.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-12 text-center">
        <span className="text-5xl mb-4 block">🎉</span>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No Active Incidents</h3>
        <p className="text-gray-600">All systems running smoothly!</p>
      </div>
    );
  }

  const getPriorityColor = (priority) => {
    if (priority.includes('Critical')) return 'bg-red-100 text-red-800 border-red-200';
    if (priority.includes('High')) return 'bg-orange-100 text-orange-800 border-orange-200';
    if (priority.includes('Moderate')) return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    return 'bg-blue-100 text-blue-800 border-blue-200';
  };

  const getStateColor = (state) => {
    if (state === 'Resolved') return 'bg-green-100 text-green-800';
    if (state === 'In Progress') return 'bg-blue-100 text-blue-800';
    return 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Incidents</h2>
        <p className="text-sm text-gray-600 mt-1">AI agents are actively monitoring and resolving incidents</p>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Incident #
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Description
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Priority
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                State
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Assigned AI Agent
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Category
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Updated
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {incidents.map((incident) => (
              <tr key={incident.id} className="hover:bg-gray-50 cursor-pointer">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-blue-600">{incident.number}</div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-900 max-w-md">{incident.short_description}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full border ${getPriorityColor(incident.priority)}`}>
                    {incident.priority}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStateColor(incident.state)}`}>
                    {incident.state}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <span className="text-xl mr-2">🤖</span>
                    <div>
                      <div className="text-sm font-medium text-gray-900">{incident.assigned_to}</div>
                      <div className="text-xs text-gray-500">AI Agent</div>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-600">{incident.category}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {formatRelativeTime(incident.updated_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IncidentsList;
